<template>
  <v-select v-model="model"
            :item-text="selectBoxItemTitle"
            :item-value="selectBoxItemValue"
            :items="items"
            :label="label"
            :menu-props="{closeOnContentClick: true, offsetY: true}"
            append-icon="icon-arrow-down"
            class="ma-0 pa-0 fin-select-box"
            height="48px"
            hide-details
            outlined
            autofocus
            :return-object="returnAsObject"
  >
    <template v-if="newList"
              #append-item>
      <v-spacer style="border: 1px solid lightgray;"/>
      <v-btn depressed
             text
             tile
             class="font-weight-light"
             style="width: 100%"
             @click.native="createNewList"
      >
        <div style="text-align: left; width: 100%"> {{ newListLabel }}
          <slot name="icon">
            <v-icon>icon-plus</v-icon>
          </slot>
        </div>
      </v-btn>
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'FinSelectBox',
  props: {
    /** The label for the select */
    label: {
      type: String,
      default: ''
    },
    /** The items available for selection */
    items: {
      type: Array,
      default: () => []
    },
    /** Enables the creation of a new list item */
    newList: {
      type: Boolean,
      default: undefined
    },
    /** Sets the label for the + button */
    newListLabel: {
      type: String
    },
    /** The attribute name of the object to use as the label of the selection item */
    selectBoxItemTitle: {
      type: String,
      default: undefined
    },
    /** The attribute name of the object to use as the value of the selection item */
    selectBoxItemValue: {
      type: String,
      default: undefined
    },
    /** The selected item */
    value: {},
    /** Return the complete object instead of the value configured via selectBoxItemValue */
    returnAsObject: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      model: this.value
    }
  },
  methods: {
    createNewList() {
      if (this.model === this.newListLabel) {
        this.$emit('input', this.model)
      }
      this.model = this.newListLabel
    }
  },
  watch: {
    model(val) {
      /**
       * Emits the selection or the newListLabel if newList is enabled and the button clicked
       * @event input
       * @type {Object} the selected item
       */
      this.$emit('input', val)
    },
    value(val) {
      if (val !== this.model) {
        this.model = val
      }
    }
  },
  mounted() {
    if (this.model) {
      /**
       * Emits the selection
       * @event input
       * @type {Object} the selected item id or the complete object (if returnAsObject is set)
       */
      this.$emit('input', this.returnAsObject ? this.model : this.model[this.selectBoxItemValue])
    }
  },
}
</script>

<style lang="scss" scoped>
@import "./../../../styles/variables.scss";

.fin-select-box {
  .v-select__selection,
  .v-icon:before {
    color: $fin-color-primary-dark !important;
  }

  .v-input__slot {
    min-height: unset !important;
  }
}

</style>
